import React, { useState } from "react";
import AdminTable from "../../Common/AdminTable";
import AdminModal from "../../Common/AdminModal";
import { UserCheck, MessageSquare, CheckCircle2 } from "lucide-react";

const INITIAL_MENTORS = [
  {
    id: "MNT-01",
    name: "Dr. Aniruddh Basu",
    subject: "History & Art & Culture",
    students_assigned: 42,
    status: "Active",
    rating: 4.8,
  },
  {
    id: "MNT-02",
    name: "Meenakshi Sundaram",
    subject: "Polity & Governance",
    students_assigned: 58,
    status: "Active",
    rating: 4.9,
  },
  {
    id: "MNT-03",
    name: "Vikramaditya Rao",
    subject: "Geography & Environment",
    students_assigned: 35,
    status: "Active",
    rating: 4.7,
  },
];

export default function MentorManagementPage() {
  const [mentors, setMentors] = useState(INITIAL_MENTORS);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [assignStudentEmail, setAssignStudentEmail] = useState("");
  const [toastMessage, setToastMessage] = useState("");

  const showToast = (msg) => {
    setToastMessage(msg);
    setTimeout(() => setToastMessage(""), 3500);
  };

  const handleAssign = () => {
    if (!assignStudentEmail.trim()) {
      alert("Please enter candidate email");
      return;
    }
    setMentors(
      mentors.map((m) =>
        m.id === selectedMentor.id
          ? { ...m, students_assigned: m.students_assigned + 1 }
          : m
      )
    );
    showToast(`Assigned ${assignStudentEmail} to ${selectedMentor.name}`);
    setSelectedMentor(null);
    setAssignStudentEmail("");
  };

  const columns = [
    {
      title: "Mentor ID",
      key: "id",
      width: "110px",
      render: (val) => <span style={{ fontWeight: 700, color: "#0284c7" }}>{val}</span>,
    },
    {
      title: "Mentor Name",
      key: "name",
      render: (val, row) => (
        <div>
          <div style={{ fontWeight: 600, color: "#1e293b" }}>{val}</div>
          <div style={{ fontSize: "12px", color: "#64748b" }}>{row.subject}</div>
        </div>
      ),
    },
    {
      title: "Students Assigned",
      key: "students_assigned",
      width: "160px",
      render: (val) => (
        <span style={{ fontWeight: 600, color: "#1e293b" }}>{val} Aspirants</span>
      ),
    },
    {
      title: "Rating",
      key: "rating",
      width: "100px",
      render: (val) => (
        <span style={{ fontWeight: 600, color: "#eab308" }}>★ {val}</span>
      ),
    },
    {
      title: "Status",
      key: "status",
      width: "110px",
      render: (val) => <span className="status-badge active">{val}</span>,
    },
    {
      title: "Action",
      key: "action",
      width: "140px",
      render: (_, row) => (
        <button
          className="admin-btn admin-btn-primary admin-btn-sm"
          onClick={() => setSelectedMentor(row)}
        >
          <UserCheck size={13} /> Assign Student
        </button>
      ),
    },
  ];

  return (
    <div>
      {toastMessage && (
        <div
          style={{
            position: "fixed",
            bottom: "24px",
            right: "24px",
            background: "#0f172a",
            color: "#ffffff",
            padding: "12px 20px",
            borderRadius: "8px",
            boxShadow: "0 10px 15px -3px rgba(0,0,0,0.3)",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            zIndex: 2000,
            fontSize: "14px",
          }}
        >
          <CheckCircle2 size={18} style={{ color: "#22c55e" }} />
          {toastMessage}
        </div>
      )}

      <AdminTable
        columns={columns}
        data={mentors}
        searchPlaceholder="Search mentors by name, subject..."
        pageSize={10}
        rowKey="id"
      />

      <AdminModal
        isOpen={Boolean(selectedMentor)}
        onClose={() => setSelectedMentor(null)}
        title={selectedMentor ? `Assign Candidate to ${selectedMentor.name}` : ""}
        maxWidth="480px"
        footer={
          <>
            <button
              className="admin-btn admin-btn-secondary"
              onClick={() => setSelectedMentor(null)}
            >
              Cancel
            </button>
            <button
              className="admin-btn admin-btn-primary"
              onClick={handleAssign}
            >
              Confirm Assignment
            </button>
          </>
        }
      >
        {selectedMentor && (
          <div>
            <p style={{ fontSize: "13px", color: "#64748b", marginBottom: "14px" }}>
              Mentor: <strong>{selectedMentor.name}</strong> ({selectedMentor.subject})
            </p>
            <div className="admin-form-group">
              <label className="admin-form-label">Candidate Email / User ID *</label>
              <input
                type="text"
                className="admin-form-input"
                placeholder="e.g. aspirant@gmail.com"
                value={assignStudentEmail}
                onChange={(e) => setAssignStudentEmail(e.target.value)}
              />
            </div>
          </div>
        )}
      </AdminModal>
    </div>
  );
}
